
export const workAuthorizationOptions = [
    { value: "Indian Citizen", label: "Indian Citizen" },
    { value: "U.S. Citizen", label: "U.S. Citizen" },
    { value: "Green Card", label: "Green Card" },
    { value: "H-1B Visa", label: "H-1B Visa" },
    { value: "H-4 Visa", label: "H-4 Visa" },
    { value: "H-4 EAD", label: "H-4 EAD" },
    { value: "L-1 Visa", label: "L-1 Visa" },
    { value: "L-2 Visa", label: "L-2 Visa" },
    { value: "F-1 Visa", label: "F-1 Visa" },
    { value: "OPT", label: "OPT" },
    { value: "CPT", label: "CPT" },
    { value: "TN Visa", label: "TN Visa" },
    { value: "J-1 Visa", label: "J-1 Visa" },
    { value: "O-1 Visa", label: "O-1 Visa" },
    { value: "E-2 Visa", label: "E-2 Visa" },
    { value: "EAD", label: "EAD" },
    { value: "Asylum Seeker", label: "Asylum Seeker" },
    { value: "Refugee", label: "Refugee" },
    { value: "TPS", label: "TPS" },
    { value: "Other", label: "Other" },
  ];
  